import { DayPicker } from 'react-day-picker';
import style from './Calendar.module.scss';

export interface CalendarProps {
  onDateClick: (date: Date) => void;
  selectedDate?: Date;
}

const Calendar = ({ onDateClick, selectedDate }: CalendarProps) => {
  const currentDate = new Date();

  const minSelectableDate = new Date(currentDate);
  minSelectableDate.setMonth(currentDate.getMonth() - 1);
  const maxSelectableDate = new Date(currentDate);
  maxSelectableDate.setDate(currentDate.getDate() + 7);

  const isDateDisabled = (date: Date) => {
    return date < minSelectableDate || date > maxSelectableDate;
  };

  return (
    <>
      <DayPicker
        mode="single"
        selected={selectedDate}
        onDayClick={onDateClick}
        disabled={isDateDisabled}
        className={style.calendar}
      />
    </>
  );
};

export default Calendar;
